import { render, staticRenderFns } from "./CallToTheHeart.vue?vue&type=template&id=1367289e&lang=pug"
import script from "./CallToTheHeart.vue?vue&type=script&lang=ts"
export * from "./CallToTheHeart.vue?vue&type=script&lang=ts"
import style0 from "./CallToTheHeart.vue?vue&type=style&index=0&id=1367289e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports